import React from 'react'
import PropTypes from 'prop-types'

/* Utils */
import {
    Box
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Components */
import Field from '../field'

/* Fields */
import useStoreLocatorFields from './useStoreLocatorFields'

const StoreLocatorFields = ({
    form,
    prefix = '',
    ...otherProps
}) => {
    const fields = useStoreLocatorFields({ form, prefix })

    return (
        <Box>
            <Field
                {...fields?.storeLocatorSearch}
                inputProps={{
                    ...otherProps
                }}
            />
        </Box>
    )
}

StoreLocatorFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string,
    otherProps: PropTypes.object
}

export default StoreLocatorFields
